import { createContext } from 'react'
import { Timeline } from 'utils/__generated__/graphql'

export type TimelinesContextType = {
  timelines: Timeline[]
}

const TimelinesContext = createContext({} as TimelinesContextType)

export default TimelinesContext
